import { BackgroundMain } from './styles';
import { useState } from 'react';

import Bg1 from 'assets/images/backgrounds/bg1.jpeg';
import Bg2 from 'assets/images/backgrounds/bg2.jpeg';
import Bg3 from 'assets/images/backgrounds/bg3.jpeg';

const images = [Bg1, Bg2, Bg3];

export const BackgroundTransition = () => {
  const [classList, setClassList] = useState([
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ]);
  const [initial, setInitial] = useState('selected');
  const time = 10000;
  const max = images.length;
  let currentIndex = 0;

  const nextImage = () => {
    currentIndex++;
    if (currentIndex >= max) {
      currentIndex = 0;
    }
    setClassList(
      classList.map((element, index) =>
        index === currentIndex ? 'selected' : ''
      )
    );
  };

  const start = () => {
    setInterval(() => {
      nextImage();
    }, time);
    setTimeout(() => {
      setInitial('none');
    }, 16000);
  };

  window.addEventListener('load', start);

  return (
    <>
      <BackgroundMain>
        <img src={Bg1} className={initial} alt="" />
        <img src={images[0]} className={classList[0]} alt="" />
        <img src={images[1]} className={classList[1]} alt="" />
        <img src={images[2]} className={classList[2]} alt="" />
      </BackgroundMain>
    </>
  );
};
